export default __webpack_public_path__ + "static/media/donation.d1a3526a.png";